import instance from '../xhrService';
import db from '../../db/db';

/**
 * Control measures
 */
const url = (id = null) => {
  return `/api/legend-items` + (id ? `/${id}` : '');
};

/** Generic Legend Item api  */
export const legendItemApi = {
  index: async (projectId = null, type = null, documentGroupId = null, search, divisionId) => {
    const isOffline = !navigator.onLine;

    if (!divisionId) {
      throw new Error('Division id is required 1');
    }

    // If offline, fetch from IndexedDB
    if (isOffline && projectId) {
      try {
        let legendItems = await db.legendItems
          .where('project_id')
          .equals(projectId)
          .toArray();

        // Filter by type if specified
        if (type) {
          legendItems = legendItems.filter(item => item.type === type);
        }

        // Filter by search term if specified
        if (search) {
          const searchLower = search.toLowerCase();
          legendItems = legendItems.filter(item => 
            item.name?.toLowerCase().includes(searchLower)
          );
        }

        return legendItems;
      } catch (error) {
        console.error('Error fetching legend items from IndexedDB:', error);
        throw error;
      }
    }

    // If online, fetch from API
    return instance
      .get(url(null), {
        params: { type, projectId, documentGroupId, divisionId, s: search, }
      })
      .then(_ => _.data);
  },
  indexByProject: (projectId, divisionId) => {
    return instance
      .get(`/api/project-legend-items`, {
        params: { projectId, divisionId }
      })
      .then((_) => _.data);
  },
  indexByProjectUsage: (projectId) => {
    return instance
      .get(`/api/projects/${projectId}/legend-items`)
      .then((_) => _.data);
  },
  fixedDetails: (projectId, doctype) => {
    const params = {}

    if (doctype) {
      params.doctype = doctype;
    }

    return instance
      .get(`/api/projects/${projectId}/fixed-details`, { params })
      .then(_ => _.data);
  },
  create: (projectId, divisionId, data) => {
    return instance
      .post(url(data.id || undefined), {
        ...data,
        projectId,
        divisionId
      })
      .then((_) => _.data);
  },
  copy: (tenantId, divisionId, regulationIds, legendIds) => {
    return instance
      .post('/api/legend-items/copy', {
        tenantId,
        divisionId,
        regulationIds,
        legendIds,
      })
      .then((_) => _.data);
  },
  createGlobal: (data) => {
    return instance.post(url(), data).then((_) => _.data);
  },
  update: (projectId, data) => {
    const reqData = { ...data };

    if (projectId) {
      reqData.projectId = projectId;
    }

    return instance.put(url(data.id), reqData).then((_) => _.data);
  },
  updateGlobal: (data) => {
    return legendItemApi.update(null, data);
  },
  destroy: (id, projectId) => {
    return instance
      .delete(url(id), {
        params: {
          projectId: projectId,
        },
      })
      .then(() => true);
  },
};

/**
 * Scope the index method of the generic {legendItemApi} with legend item type
 *
 */
export const controlMeasureApi = {
  ...legendItemApi,
  index: (projectId, divisionId) => legendItemApi.index(projectId, 'control_measure', null, '', divisionId),
};

export const pollutantApi = {
  ...legendItemApi,
  index: (projectId, divisionId) => legendItemApi.index(projectId, 'pollutant', null, '', divisionId),
};

export default legendItemApi;
